export enum Language {
    HR = 29,
    EN = 30,
    SLO = 31,
    IT = 32,
}
